import { generatePath } from 'react-router-dom';
import { formatDate } from '@ui/src';
import { RateSource } from '../../../store/types';
import { RateItem } from '../types';
import ROUTES from '../../../routes';

const formatRateList = (
  list: RateItem[],
  currency: string,
  rateSource?: RateSource[],
): RateItem[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };
    const render: Record<string, React.JSX.Element> = {};

    result.url = generatePath(ROUTES.RATE_INFO, {
      currency,
      rateId: result.id,
    });

    const currentRateSourse = rateSource?.find(
      (rateSourceItem) => rateSourceItem.id === result.rateSourceId,
    );

    render.currencyLeftId = <div>{result.currencyLeftName}</div>;
    render.currencyRightId = <div>{result.currencyRightName}</div>;
    render.rateSourceId = <div>{currentRateSourse?.name}</div>;

    render.date = <div>{formatDate(result.date, true)}</div>;

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatRateList;
